export default [
    [
        'email',
        'first_name',
        'last_name',
        'street',
        'number',
        'zip_code',
        'city',
        'phone',
        'mobile_phone',
        'gender',
        'birthdate',
        'profession',
        'height',
        'weight',
    ],

    [
        "programs",
        "max_two_hours_per_week"
    ],

    [
        "want_to_reduce_weight",
        "reduce_weight",
        "fat_percentage",
        "inbody_user_id",
        "want_fat_deposits",
        "fat_deposit_areas",
        "fat_deposit_other",
    ],

    [
        "metabolic_function",
        "weight_loss_block",
        "satiety",
        "optimize_body_shape",
        "is_reduce_cellulite",
        "do_you_work",
        "do_sports",
        "what_sport",
        "sports_times_per_week",
        "long_exercise",
        "rate_fitness",
        "physical",
        "discipline",
        "want_to_improve",
        "smoker",
        "drink_water",
        "drink_softdrink",
        "drink_coffee",
        "drink_tea",
        "drink_alcohol",
    ],

    [
        "symptoms",
        "stress_level",
        "allergies",
        "heart_attack_date",
        "thrombosis_date",
        "which_infectious_disease",
        "which_autoimmune_disease",
        "cancer_diagnosed_date",
        "cancer_diagnosed_location",
        "operation_details",
        "woman_details",
        'is_no_findings',
    ],

    [
        "medications",
        'is_no_medications',
        "botox_last_6_months",
        "botox_details",
        "filler_treatment_last_6_months",
        "filler_treatment_details",
        'is_implants',
        "silicone",
        "silicone_where",
        "metal",
        "metal_where",
        'is_active_systems',
        "implanted_active",
    ],
];
